import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow--holiday",
  "use": "icon-arrow--holiday-usage",
  "viewBox": "0 0 16 12",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 12\" id=\"icon-arrow--holiday\"><path d=\"m12.17 7-3.58 3.59L10 12l6-6-6-6-1.41 1.41L12.17 5H0v2h12.17Z\" fill=\"#fff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol